import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { AmountTD } from "./styled/AmountTD";
import { convertToMoney } from "./Money";

export class CurrencyTD extends PureComponent {
    render() {
        const innerText =
            this.props.amount !== null
                ? convertToMoney(this.props.amount, this.props.nbDecimals)
                : "";
        return (
            <AmountTD
                amount={this.props.amount}
                textAlign={this.props.align}
                className={this.props.className}
                {...this.props}
            >
                {innerText}
            </AmountTD>
        );
    }
}

CurrencyTD.propTypes = {
    align: PropTypes.string,
    amount: PropTypes.number,
    className: PropTypes.string,
    nbDecimals: PropTypes.number
};
